
import { TrashIcon } from '@vue-hero-icons/outline';

export default {
  fetchOnServer: false,
  components: { TrashIcon },
  props: {
    list: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      lendings: [],
    };
  },

  async fetch() {
    await this.fetchData();
  },

  computed: {
    totalLending() {
      return (
        this.lendings.reduce((prev, { amount }) => {
          return prev + amount;
        }, 0) || 0
      );
    },
  },

  methods: {
    create() {
      this.$vmodal.open({
        component: () => ({
          component: import('~/components/Modal/CreateLending.vue'),
          delay: 200,
          timeout: 3000,
        }),
        props: {
          close: this.fetchData,
        },
        wrapperProps: {
          clickCloseOutside: true,
          classes: 'pre-default-modal',
        },
      });
    },

    async fetchData() {
      const { data } = await this.$axios.request({
        url: '/api/person/lending/',
        method: 'get',
      });

      if (data) {
        this.lendings = data?.results;
        this.$store.commit('temp/PUT', { lendings: data?.results });
      }
    },

    async deleteTransaction(deleteId) {
      const message = this.$t("common.notify_delete");
      const confirm = await this.$vmodal.confirm({ message });
      if (!confirm) {
        return;
      }

      if (!deleteId) {
        return;
      }

      const { data } = await this.$axios.request({
        url: `/api/person/lending/${deleteId}/`,
        method: 'put',
        data: {
          delete: true,
        },
      });

      if (data) {
        await this.fetchData();
        this.$toast.open({ message: this.$t("common.update_success") });
      }
    },
  },
};
